import store from "@/store";

const pwaUtilities = () => {
  window.addEventListener('beforeinstallprompt', (evt) => {
    evt.preventDefault(); // prevents Add-to-Homescreen bottom-bar on Chrome (Android)
    store.dispatch('installPWAEvent', evt);
  });

  triggerPWAUpdate();
}

function triggerPWAUpdate() {
  if (window.matchMedia('(display-mode: standalone)').matches) {
    document.onvisibilitychange = async() => {
      if (!document.hidden && 'serviceWorker' in navigator) {
        const registration = navigator.serviceWorker.ready;
        registration.update()
      }
    }
  }
}

export default pwaUtilities;
